/**
 * DESIGN.md §2.4: the app's existing theme setting stays the only switch.
 * The new HOS UI reads its dark palette from `:root[data-hos-theme="dark"]`
 * (hos-tokens.css), so whoever writes `data-theme` also mirrors it here.
 * Light is the default, therefore the attribute is removed instead of set to "light".
 */
export function applyHosTheme(theme: "light" | "dark", root: HTMLElement = document.documentElement) {
  if (theme === "dark") root.setAttribute("data-hos-theme", "dark");
  else root.removeAttribute("data-hos-theme");
}
